
<nav class="navbar navbar-expand-lg navbar-light bg-white shadow-sm px-3">

  <a class="navbar-brand" routerLink="/" (click)="close()">
    <img
      src="GeorgeStoreIcon.png"
      alt="GeorgeStore"
      class="navbar-logo">
      GeorgeStore
  </a>

  <!-- Burger btn -->
  <button 
    class="navbar-toggler" 
    type="button"
    (click)="toggle()">
    <span class="navbar-toggler-icon"></span>
  </button>

  <!-- Menu -->
  <div 
    [ngbCollapse]="!isMenuOpen" 
    class="collapse navbar-collapse">

    <ul class="navbar-nav ms-auto text-center text-lg-start">

      <li class="nav-item mt-2 mt-lg-0">
        <a 
          class="nav-link btn btn-outline-primary ms-lg-2"
          routerLink="/" 
          (click)="close()"
          routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true}">
          Home
        </a>
      </li>

      @if (!isLogged()) {
        <li class="nav-item">
          <a 
            class="nav-link btn btn-outline-primary ms-lg-2" 
            routerLink="/auth/login" 
            (click)="close()"
            routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true}">
            Sign in
          </a>
        </li>

        <li class="nav-item">
          <a 
            class="nav-link btn btn-outline-primary ms-lg-2 mt-2 mt-lg-0 px-3"
            routerLink="/auth/register"
            (click)="close()"
            routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true}">
            Register
          </a>
        </li>
      }
      @else {
        
        <li class="nav-item">
          <button
            class="nav-link btn btn-outline-danger ms-lg-2 mt-2 mt-lg-0 px-3 w-100"
            routerLink="/"
            (click)="logout()">
            Logout
          </button>
        </li>


        <li class="nav-item">
          <a
            class="nav-link ms-lg-2"
            routerLink="/profile"
            (click)="close()"
            routerLinkActive="active">

            <i class="bi bi-person-circle fs-5"></i>

          </a>
        </li>

        <li class="nav-item">
          <a 
            class="nav-link position-relative ms-lg-2 d-inline-flex align-items-center justify-content-center"
            routerLink="/cart"
            (click)="close()"
            routerLinkActive="active">
            <i class="bi bi-cart3 fs-5"></i>
            
            @if (itemsCount()) {
              <span
                class="position-absolute badge rounded-pill bg-danger"
                style="top: -2px; right: -8px; font-size: 0.6rem;">
                {{ itemsCount() }}
              </span>
            }

          </a>
        </li>

      }


    </ul>
  </div>

</nav>